import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import attendantServiceUnitReadAction from './attendantServiceUnitRead.action.json' assert { type: 'json' }

const attendantServiceUnitReadDefinition = defineReadAutoAction(
  attendantServiceUnitReadAction,
  'attendantServiceUnit',
)

export default attendantServiceUnitReadDefinition
